import { useCallback, useMemo } from 'react';

export function useIsDayExcluded(availableDates: Date[] | undefined) {
  const dates = useMemo(
    () => availableDates?.map((date) => date.toDateString()),
    [availableDates]
  );
  return useCallback(
    (date: Date) => (dates ? !dates.includes(date.toDateString()) : false),
    [dates]
  );
}
